import { Fragment, useMemo } from 'react'
import {
  BCProduct,
  EnrollmentModifierOptions,
} from '@cerifi/ecomm/bigcommerce/types/product'
import useEnrollmentStore from '@cerifi/state/enrollment-store'
import { Divider } from '@cerifi/ui/components/divider'

/** Used by CFP Education - Instructor led to determine the month you take your course.
 * Communicates directly with the EnrollmentStore to keep track of what month they select.
 * Then when the user adds their course to the cart the enrollment store will automatically
 * add that month as a product 'option'
 */
export const EnrollmentInstructorLedMonthPicker = (props: {
  product: BCProduct
}) => {
  const [monthOption, setSelectedMonthOption, showValidation] =
    useEnrollmentStore((state) => [
      state.monthToStartLabel,
      state.setSelectedMonthOption,
      state.showValidation,
    ])
  const monthToStartOptions = useMemo(
    () =>
      props.product.modifiers?.find(
        (x) => x.display_name === EnrollmentModifierOptions.StartMonth
      ),

    [props.product]
  )

  return (
    <div>
      <label className="font-medium">Course dates/Cohort</label>

      <fieldset className="xs:grid-cols-2 relative mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {monthToStartOptions?.option_values.map((o) => (
          <Fragment key={o.label}>
            <div className="relative">
              <div className="bg-grayBlue-50 border border-neutral-200 p-4">
                <input
                  type="radio"
                  id={o.label}
                  value={o.label}
                  checked={monthOption === o.label}
                  onChange={() => setSelectedMonthOption(o.label)}
                  name="What month would you like to start"
                  className="mr-3"
                />
                <label
                  htmlFor={o.label}
                  className="left-13 absolute inset-y-0 right-0 flex cursor-pointer items-center font-medium"
                >
                  {o.label}
                </label>
              </div>
            </div>
          </Fragment>
        ))}
      </fieldset>
      {showValidation && !monthOption && (
        <p className="text-error-700 text-xs mt-2">
          Please pick a course date/cohort
        </p>
      )}

      <Divider className="my-6" />
    </div>
  )
}
